import React, { useEffect, useRef, useState } from 'react';
import BusDriverImg from '../img/BusDriver.svg';
import SmartVideo from './SmartVideo';
import FadeInImage from './FadeInImage';
import ContactFormModal from './ContactFormModal';
import { useTranslation } from '../i18n/useTranslation';
import { trackContactClick } from '../track';

const HeroSection = () => {
  const { t } = useTranslation();
  const videoRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Force video play on mobile devices
    const video = videoRef.current;
    if (video) {
      video.muted = true;
      video.playsInline = true;
      const playVideo = () => {
        video.play().catch(error => {
          console.log('Video autoplay failed:', error);
          // Try playing again after user interaction
          document.addEventListener('touchstart', () => {
            video.play();
          }, { once: true });
        });
      };
      playVideo();
    }
  }, []);
  return (
    <section className="relative pt-0 pb-96 lg:pt-0 lg:pb-[120] xl:pb-[140]" style={{ zIndex: 1, paddingBottom: '50rem' }}>
      {/* Video Container - geht jetzt weiter nach oben */}
      <div className="absolute inset-x-0 pointer-events-none top-0 bottom-0 min-[1800px]:bottom-[-600px]" style={{
        zIndex: -1,
        overflow: 'hidden'
      }}>
        <SmartVideo
          src="/header-animation_v4.mp4"
          poster="/img/BusDriver.svg"
          className="absolute w-full object-cover"
          style={{
            height: '100%',
            objectPosition: 'center 20%'
          }}
          autoPlay
          muted
          loop
          playsInline
        />
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative" style={{ zIndex: 10, paddingTop: '8rem' }}>
        <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-[400px] md:min-h-[500px]">
          <div className="text-left min-[1800px]:max-w-[1600px] min-[1800px]:ml-20 relative min-[1800px]:top-[8rem]">
            <h1 className="text-3xl sm:text-5xl lg:text-6xl min-[1800px]:text-[5rem] min-[1800px]:leading-[1.1] font-extrabold text-brand-dark-blue leading-tight -ml-2 sm:ml-0">
              {t('hero.titleMobile') ? (
                t('hero.titleMobile').split('\n').map((line, index) => (
                  <span key={index} style={{ whiteSpace: 'nowrap', display: 'block' }}>
                    {line}
                  </span>
                ))
              ) : (
                t('hero.title')
              )}
            </h1>
            <p className="mt-6 text-lg min-[1800px]:text-[1.75rem] min-[1800px]:mt-6 min-[1800px]:leading-[1.25] text-gray-600 max-w-xl min-[1800px]:max-w-[1600px] -ml-2 sm:ml-0">
              {t('hero.subtitle')}
            </p>
            <button
              onClick={() => {
                trackContactClick('hero');
                setIsModalOpen(true);
              }}
              className="mt-10 inline-block gradient-button gradient-button-hover text-white font-bold text-lg min-[1800px]:text-[1.5rem] min-[1800px]:px-12 min-[1800px]:py-5 min-[1800px]:mt-8 rounded-full px-10 py-4 transition-transform transform hover:scale-105"
            >
              {t('hero.ctaButton')}
            </button>
          </div>
        </div>
      </div>
      {/* Desktop: Container außerhalb des containers für echte rechtsbündige Positionierung */}
      <div className="hidden lg:block absolute right-0 top-[40%] min-[1800px]:top-[50%]" style={{ zIndex: 20 }}>
        <div className="bg-white/90 backdrop-blur-sm overflow-hidden w-[420px] h-[324px] xl:w-[480px] xl:h-[371px] min-[1800px]:w-[720px] min-[1800px]:h-[556px]"
             style={{
               borderTopLeftRadius: '500px',
               borderBottomLeftRadius: '500px',
               borderTopRightRadius: '0px',
               borderBottomRightRadius: '0px',
               boxShadow: '0 0 60px rgba(59, 130, 246, 0.7), 0 0 120px rgba(59, 130, 246, 0.5), rgba(14, 103, 231, 0.5) 0px 8px 30px 0px'
             }}>
          <FadeInImage
            src={BusDriverImg}
            alt={t('hero.imageAlt')}
            className="w-full h-full object-cover"
            style={{
              objectPosition: 'center'
            }}
            width="480"
            height="371"
            loading="eager"
            fetchpriority="high"
            showSkeleton={false}
          />
        </div>
      </div>

      {/* Mobile: BusDriver Bild unter dem Demo Button - rechtsbündig mit halbrunder Form */}
      <div className="lg:hidden mt-6 relative" style={{ marginRight: '-1rem' }}>
        <div className="ml-auto bg-white/90 backdrop-blur-sm overflow-hidden w-[320px] h-[250px] sm:w-[400px] sm:h-[310px] md:w-[460px] md:h-[355px]"
             style={{
               borderTopLeftRadius: '500px',
               borderBottomLeftRadius: '500px',
               borderTopRightRadius: '0px',
               borderBottomRightRadius: '0px',
               boxShadow: '0 0 60px rgba(59, 130, 246, 0.7), 0 0 120px rgba(59, 130, 246, 0.5), rgba(14, 103, 231, 0.5) 0px 8px 30px 0px',
               position: 'relative',
               zIndex: 20
             }}>
          <FadeInImage
            src={BusDriverImg}
            alt={t('hero.imageAlt')}
            className="w-full h-full object-cover"
            style={{
              objectPosition: 'center'
            }}
            width="480"
            height="371"
            loading="eager"
            fetchpriority="high"
            showSkeleton={false}
          />
        </div>
      </div>

      {/* Contact Form Modal */}
      <ContactFormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
};

export default HeroSection;